// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const idnr: CountryValidator<"ZA", ParsedPersonId> =
  createValidator("za.idnr", 175);

export default idnr;
export const compact = idnr.compact;
export const format = idnr.format;
export const validate = idnr.validate;
export const generate = (): string =>
  idnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator za.idnr cannot generate values",
    );
  })();
export const parse = idnr.parse;
